import { useEffect, useState } from 'react';
import Pricing from '@/components/Pricing';
import { getActiveProductsWithPrices } from '@/utils/supabase-client';
import Features from '@/components/Features';
import LoadingDots from '@/components/LoadingDots';
import { SEOMeta } from '@/templates/SEOMeta';
import { useTranslations } from 'next-intl';
import { getI18nProps } from '@/utils/i18n';
import { generateFAQPageSchema, generateSoftwareApplicationSchema } from '@/utils/schema';

export default function Products({ seoMeta }) {
  const t = useTranslations('pricing');
  const [products, setProducts] = useState(null);
  const pricingFaqs = [
    { question: t('seo.faq.trial.question'), answer: t('seo.faq.trial.answer') },
    { question: t('seo.faq.integrations.question'), answer: t('seo.faq.integrations.answer') },
    { question: t('seo.faq.payouts.question'), answer: t('seo.faq.payouts.answer') }
  ];

  const getProducts = async () => {
    setProducts(await getActiveProductsWithPrices());
  };

  useEffect(() => {
    {
      products == null &&
      getProducts();
    }
  }, [products]);

  return(
    <>
      <SEOMeta
        title={seoMeta?.title || t('seo.title')}
        description={seoMeta?.description || t('seo.description')}
        keywords={seoMeta?.keywords || t('seo.keywords')}
        url={seoMeta?.url || "/pricing"}
        structuredData={[
          generateSoftwareApplicationSchema({
            description: seoMeta?.description || t('seo.description'),
            url: 'https://afivio.com/pricing'
          }),
          generateFAQPageSchema(pricingFaqs)
        ]}
      />
      <div className="relative bg-gradient-to-b from-white to-gray-200 py-24">
        <div className="wrapper">
          <div className="mx-auto mb-1 max-w-4xl text-center">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold">{t('page.heading')}</h1>
            <p className="mt-4 text-base sm:text-lg text-gray-600">{t('page.subtitle')}</p>
          </div>
          <div className="py-10">
            {
              products !== null ?
                <Pricing products={products}/>
              :
                <div className="flex items-center justify-center">
                  <LoadingDots small/>
                </div>
            }
          </div>
          <div className="relative py-10">
            <Features/>
          </div>
        </div>
      </div>
    </>
  );
}
export async function getStaticProps(ctx) {
  const { getI18nPropsWithSeo } = await import('@/utils/i18n');
  return getI18nPropsWithSeo(ctx, 'pricing', '/pricing');
}
